import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class ClientsRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('account') declare accountService: Service.Account;

	override beforeModel(): Promise<unknown> {
		document.body.id = 'page-clients';

		return this.navigationService.initialRequestsPromise;
	}

	override afterModel(_model: unknown, transition: PublicTransition): void {
		if (this.accountService.isAgency) {
			return;
		}

		if (!transition.sequence) {
			this.navigationService.replaceRoute('index');
		} else {
			transition.abort();
		}
	}
}
